// extracted by mini-css-extract-plugin
export default {"form":"ProjectForm_form__dNX7W","projects_grid":"ProjectForm_projects_grid__Enwu-"};